
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings",
      function () {
        return require("private-next-pages/settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings"])
      });
    }
  